import { Drawer } from "antd";
import { useRef, useState } from "react";

import styles from "./index.less";

import { CardMessage as CardMessageType } from "@/services/chat";

type LinkProps = {
  msg: CardMessageType;
};

const CardMessage = (props: LinkProps) => {
  const { msg } = props;
  const { title, description, headUrl, url } = msg;
  const [drawerVisible, setDrawerVisible] = useState(false);
  const linkRef = useRef<HTMLDivElement>(null);

  const handleVisible = () => {
    // 微信公众号不能ifream 嵌入
    if (url?.includes("mp.weixin.qq.com")) {
      window.open(url);
    } else {
      setDrawerVisible(true);
    }
  };

  return (
    <div className={styles["content-card"]}>
      <div
        className={styles["content-link"]}
        onClick={handleVisible}
        ref={linkRef}
      >
        <div className={styles.title}>{title}</div>
        <div className={styles.bottom}>
          <div className={styles.desc}>{description}</div>
          <img alt="" src={headUrl} className={styles.thumb} />
        </div>
      </div>
      <Drawer
        className={styles["link-drawer"]}
        title={title}
        width={"100vw"}
        onClose={() => {
          setDrawerVisible(false);
        }}
        footer={null}
        open={drawerVisible}
        destroyOnClose
        mask={false}
      >
        {/* <div className={styles.phone}>
          <div className={styles['phone-content']}>
          </div>
        </div> */}
        {/* <iframe src={url} style={{ height: '60vh', width: '100%' }} /> */}
        <iframe
          src={url}
          style={{ width: "100%", height: "100%" }}
          className={styles.iframe}
        />
      </Drawer>
    </div>
  );
};

export default CardMessage;
